import type { Boundary, TrimSnapshot } from "../types/project";

export type HistoryEntry = {
  label: string;
  before: TrimSnapshot;
  after: TrimSnapshot;
  boundary?: Boundary;
};

export type HistoryState = {
  undo: HistoryEntry[];
  redo: HistoryEntry[];
};

export const EMPTY_HISTORY: HistoryState = { undo: [], redo: [] };

export function commitHistory(
  state: HistoryState,
  entry: HistoryEntry,
  capacity = 10,
): HistoryState {
  if (sameTrim(entry.before, entry.after)) return state;
  return { undo: [...state.undo, entry].slice(-capacity), redo: [] };
}

export function undoHistory(
  state: HistoryState,
  current: TrimSnapshot,
): { state: HistoryState; value: TrimSnapshot } {
  const entry = state.undo.at(-1);
  if (!entry) return { state, value: current };
  return {
    state: { undo: state.undo.slice(0, -1), redo: [...state.redo, entry] },
    value: entry.before,
  };
}

export function redoHistory(
  state: HistoryState,
  current: TrimSnapshot,
): { state: HistoryState; value: TrimSnapshot } {
  const entry = state.redo.at(-1);
  if (!entry) return { state, value: current };
  return {
    state: { undo: [...state.undo, entry], redo: state.redo.slice(0, -1) },
    value: entry.after,
  };
}

function sameTrim(a: TrimSnapshot, b: TrimSnapshot): boolean {
  return a.startFrame === b.startFrame && a.endFrame === b.endFrame;
}
